import * as msal from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ADAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_ADAL_TENANT}`,
    redirectUri: process.env.REACT_APP_ADAL_REDIRECT_URI
  },
  cache: {
    cacheLocation: "localStorage"
  },
  system: {
    loadFrameTimeout: 30000
  }
};

export const accessTokenRequest = {
  scopes: [process.env.REACT_APP_ADAL_API_SCOPE]
};

const msalInstance = new msal.PublicClientApplication(msalConfig);

export async function initializeAuth() {
  await msalInstance.initialize();
  const response = await msalInstance.handleRedirectPromise();

  if (response && response.account) {
    msalInstance.setActiveAccount(response.account);
  }

  const active = msalInstance.getActiveAccount();
  if (!active) {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0]);
    }
  }
}

export async function ensureSignedIn() {
  const active = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
  if (active) {
    msalInstance.setActiveAccount(active);
    return active;
  }

  await msalInstance.loginRedirect(accessTokenRequest);
  return null;
}

export async function getAccessToken() {
  let account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

  if (!account) {
    await ensureSignedIn();
    return null;
  }

  msalInstance.setActiveAccount(account);

  try {
    const result = await msalInstance.acquireTokenSilent({
      ...accessTokenRequest,
      account
    });

    return result.accessToken;
  } catch (error) {
    if (error instanceof msal.InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({
        ...accessTokenRequest,
        account
      });
      return null;
    }

    throw error;
  }
}

export default msalInstance;


// WEBPACK FOOTER //
// ./src/services/Auth.js